import { localDeleteStorage, localGetStorage } from '@/lib/storage';
import { initStorage } from '@/lib/util';
import { toast } from 'react-toastify';
type errorResProps = {
  code: number;
  msg: string;
  path?: string;
  isBack?: boolean;
};
export default function ErrorRes({ code, msg, path, isBack = true }: errorResProps) {
  // @@##$$ path로 에러 관련 전송체크

  // const navigate = useNavigate();

  if (code === 404) {
    // toast.success('로그인 인증시간이 만료되었습니다.');
    disconnectDeepLink();
    expireAuth();
    alert('로그인 인증시간이 만료되었습니다.');
    window.location.href = process.env.REACT_APP_REDIRECT || 'https://shuffle.hupayx.io/';
    // window.open('https://shuffle.hupayx.io/');
    // navigate('/signIn');
  } else {
    toast.error(`${code}:${msg}`);
    if (isBack) {
      window.history.back();
    }
    // navigate('/wallet');
  }
}

const expireAuth = () => {
  initStorage();
};

export const disconnectDeepLink = () => {
  // 메타마스크 연결 해제
  const re = localGetStorage('WALLETCONNECT_DEEPLINK_CHOICE') || null;
  if (re) {
    // walletconnect 해제
    localDeleteStorage('WALLETCONNECT_DEEPLINK_CHOICE');
  }
};
